import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TsComponent } from '../../../ts.component';
import { JupiterPanelDef } from '../../types';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TsButtonModule, TSIconModule } from 'tsui';
import { FormsModule } from '@angular/forms';
import { AccountColorBackgroundDirective } from '@shared/directives/account-color-background.directive';
import { NgClass } from '@angular/common';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PermissionSlotPipe } from '@modules/jupiter/@pipes/permission-slot.pipe';
import { PermissionSlot } from '@modules/jupiter/@store/types';

@Component({
  selector: 'jupiter-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss'],
  standalone: true,
  imports: [
    MatLegacyMenuModule,
    MatLegacyButtonModule,
    TSIconModule,
    TsButtonModule,
    FormsModule,
    AccountColorBackgroundDirective,
    NgClass,
    DirectivesModule,
    PermissionSlotPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelHeaderComponent extends TsComponent {
  @Input({ required: true }) panelDef: JupiterPanelDef<any>;
  @Input({ required: true }) editMode = false;
  @Output() startEditLayout = new EventEmitter<void>();
  @Output() cancelEditLayout = new EventEmitter<void>();
  @Output() saveLayout = new EventEmitter<void>();

  PermissionSlot = PermissionSlot;
}
